import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react'
import React from 'react'

// Layouts
import PresenterLayout from '../presenter/layout/PresenterLayout'
import RequireAuditAccess from '../audit/RequireAuditAccess'
import AdminLayout from '../admin/layout/AdminLayout'
import UserLayout from '../user/layout/UserLayout'
import ProtectedFeature from './ProtectedFeature'
import RequireAuth from './RequireAuth'

// Exams
import StudentParticipationDetails from '../../pages/exam/student/StudentParticipationDetails'
import AllParticipations from '../../pages/exam/faculty/AllExamsParticipations'
import ExamParticipation from '../../pages/exam/faculty/ExamParticipation'
import AddQuestions from '../../pages/exam/faculty/AddQuestions'
import ExamAttempt from '../../pages/exam/student/ExamAttempt'
import EditExam from '../../pages/exam/faculty/EditExam'
import Evaluate from '../../pages/exam/faculty/Evaluate'
import AddExam from '../../pages/exam/faculty/AddExam'
import Scores from '../../pages/exam/student/Scores'
import Exams from '../../pages/exam/Exams'
import Exam from '../../pages/exam/Exam'

// Study Material
import AddMaterial from '../../pages/study-material/AddMaterial'
import FacultyDashboard from '../../pages/faculty/Dashboard'
import Materials from '../../pages/study-material/Materials'
import Material from '../../pages/study-material/Material'
import Notfound from '../../pages/Notfound'


// Admin
import DepartmentAcademicRuleChecklist from '../../pages/admin/academic-program/DeparmentAcademicRuleCheklist'
import AcademicProgressAuditors from '../../pages/admin/academic-program/AcademicProgressAuditors'
import AdminAcademicProgressAudit from '../../pages/admin/academic-program/AcademicProgressAudit'
import InstituteAcademicRules from '../../pages/admin/academic-program/InstituteAcademicRules'
import ResumeTemplates from '../../pages/admin/resume-builder/ResumeTemplates'
import ResumeEntities from '../../pages/admin/resume-builder/ResumeEntities'
import ResumeTemplate from '../../pages/admin/resume-builder/ResumeTemplate'
import FeedbackSettings from '../../pages/admin/feedback/FeedbackSettings'
import Announcements from '../../pages/admin/announcements/Announcements'
import Announcement from '../../pages/admin/announcements/Announcement'
import HybridClassVideosRepository from '../../alive-academics/pages/admin/hybrid-class-videos/HybridClassVideosRepository'
import ResumeForms from '../../pages/admin/resume-builder/ResumeForms'
import ResumeForm from '../../pages/admin/resume-builder/ResumeForm'
// import TemporaryBatches from '../../pages/admin/TemporaryBatches'
import AttendanceAudit from '../../pages/admin/AttendanceAudit'
import ManageAccounts from '../../pages/admin/ManageAccounts'
// import Feedback from '../../pages/admin/feedback/Feedback'
import ControlPanel from '../../pages/admin/ControlPanel'
// import ApiSettings from '../../pages/admin/ApiSettings'
// import Institution from '../../pages/admin/Institution'
// import Recording from '../../pages/admin/Recordings'
import Analytics from '../../pages/admin/AdminDashboard'
import EmbeddBbb from '../../pages/common/EmbeddBbb'
import AdminSignin from '../../pages/admin/Signin'
import Password from '../../pages/admin/Password'
import LiveClass from '../../pages/common/Audit'
// import Home from '../../pages/admin/Home'

// Audit Pages
import AuditStudyMaterialsList from '../audit/study-materials/AuditStudyMaterialsList'
import AuditQuestionBanksList from '../audit/questionbanks/AuditQuestionBanksList'
import StudyMaterialsStats from '../audit/study-materials/StudyMaterialsStats'
import AuditDiscussionsList from '../audit/discussions/AuditDiscussionsList'
import QuestionBanksStats from '../audit/questionbanks/QuestionBanksStats'
import AuditStudyMaterials from '../../pages/audit/AuditStudyMaterials'
import AuditQuestionBanks from '../../pages/audit/AuditQuestionBanks'
import DiscussionsStats from '../audit/discussions/DiscussionsStats'
import AssignmentsStats from '../audit/assignments/AssignmentsStats'
import AuditAssignments from '../../pages/audit/AuditAssignments'
import AuditDiscussions from '../../pages/audit/AuditDiscussions'
import AuditQuizzesList from '../audit/quizzes/AuditQuizzesList'
import AssignmentList from '../audit/assignments/AssignmentList'
import AuditDashboard from '../../pages/audit/AuditDashboard'
import AuditExamsList from '../audit/exams/AuditExamsList'
import AuditQuizzes from '../../pages/audit/AuditQuizzes'
import FacultyAudit from '../../pages/audit/FacultyAudit'
import QuizzesStats from '../audit/quizzes/QuizzesStats'
import AuditExams from '../../pages/audit/AuditExams'
import AuditingLayout from '../audit/AuditingLayout'
import ExamsStats from '../audit/exams/ExamsStats'

// Discussions
import MyDiscussions from '../../pages/forum/MyDiscussions'
import Discussions from '../../pages/forum/Discussions'
import Discussion from '../../pages/forum/Discussion'

// Students Resume Builder
import ResumeBuilderForm from '../../pages/student/resume-builder/ResumeBuilderForm'
import ResumePreview from '../../pages/student/resume-builder/ResumePreview'
// import SubjectOnlineCourses from '../../pages/subject/SubjectOnlineCourses'
import SubjectClassSessions from '../../pages/subject/SubjectClassSessions'
import SubjectMaterials from '../../pages/subject/SubjectStudyMaterials'
import SubjectDiscussions from '../../pages/subject/SubjectDiscussions'
import SubjectAssignments from '../../pages/subject/SubjectAssignments'
import AiMentorFaculty from '../../pages/subject/AiMentorFaculty'
import SubjectDashboard from '../../pages/subject/SubjectFeeds'
import SubjectClasses from '../../pages/subject/SubjectClasses'
import SubjectExams from '../../pages/subject/SubjectExams'
import ClassSession from '../../pages/subject/ClassSession'
import Subjects from '../../pages/common/Subjects'
import Subject from '../../pages/common/Subject'

// Academics
// import AcademicProgressAudit from '../../pages/faculty/proctoring/audit/AcademicProgressAudit'
// import Proctees from '../../pages/faculty/proctoring/Proctees'
// import Proctee from '../../pages/faculty/proctoring/Proctee'
// import Academics from '../../pages/student/Academics'

// Quiz and questionbanks
import QuestionBanks from '../../pages/faculty/questionbank/QuestionBanks'
import QuestionBank from '../../pages/faculty/questionbank/QuestionBank'
import StudentQuiz from '../../pages/student/quiz/StudentQuiz'
import QuizAttempt from '../../pages/student/quiz/QuizAttempt'
import Quizzes from '../../pages/faculty/quiz/Quizzes'
import Quiz from '../../pages/faculty/quiz/Quiz'

// Faculty Pages
import EvaluateAssignment from '../../pages/faculty/EvaluateAssignment'
import PresenterRecording from '../../pages/faculty/Recording'
import Assignment from '../../pages/faculty/Assignment'
import Attendence from '../../pages/faculty/Attendence'

// Students
import SessionFeedback from '../../pages/student/SessionFeedback'
import StudentDashboard from '../../pages/student/Dashboard'
import UserAssignment from '../../pages/student/Assignment'
import UserAttendence from '../../pages/student/Attendence'
import Leaderboard from '../../pages/student/Leaderboard'

// General Pages
import StreamSessionEnded from '../../pages/common/StreamSessionEnded'
import PageNotFound from '../../pages/PageNotFound'
import NetworkError from '../../pages/NetworkError'
import ExamNotfound from '../../pages/ExamNotFound'
import FAQs from '../../pages/FAQs'

// Admission exams
import AdmissionExamWorksheetUpload from '../../pages/admission-exam/AdmissionExamWorksheetUpload'
import CandidateParticipationResult from '../../pages/admission-exam/CandidateParticipationResult'
import AdmissionExamsRequireAuth from '../admission-exam/layout/AdmissionExamsRequireAuth'
import AdmissionExamParticipation from '../../pages/admission-exam/ExamParticipation'
import AdmissionExamEvaluate from '../../pages/admission-exam/AdmissionExamEvaluate'
import AdmissionExamAttempt from '../../pages/admission-exam/AdmissionExamAttempt'
import CreateAdmissionExam from '../../pages/admission-exam/CreateAdmissionExam'
import AdmissionExamLayout from '../admission-exam/layout/AdmissionExamLayout'
import AdmissionExams from '../../pages/admission-exam/AdmissionExams'
import CandidateLogin from '../../pages/admission-exam/CandidateLogin'
import CandidateExams from '../../pages/admission-exam/CandidateExams'
import AdmissionExam from '../../pages/admission-exam/AdmissionExam'
import ThankYouPage from '../../pages/admission-exam/ThankYouPage'

// Signin
import ERPSessionSingin from '../../pages/ERPSessionSignin'
import DebugLogs from '../../pages/admin/logging/DebugLogs'
import AuditClassSessions from '../../pages/audit/AuditClassSessions'
import ClassSessionStats from '../audit/class-sessions/ClassSessionsStats'
import AuditClassSessionsList from '../audit/class-sessions/ClassSessionsList'
import WebinarRoom from '../../pages/meetings/WebinarRoom'
import MeetingRecorder from '../../pages/meetings/MeetingRecorder'
import OnlineMeetings from '../../pages/meetings/OnlineMeetings'
import OnlineMeetingDetails from '../../pages/meetings/OnlineMeetingDetails'
import AliveLogin from '../../pages/AliveLogin'
import OnlineMeetingsHome from '../../pages/meetings/OnlineMeetingsHome'
import AuditMeetings from '../../pages/audit/AuditMeetings'
import MeetingsStats from '../audit/meetings/MeetingsStats'
import MeetingFeedback from '../../pages/meetings/MeetingFeedback'
import MeetingsList from '../audit/meetings/MeetingList'
import FacultyMaterials from '../../pages/study-material/FacultyMaterials'
import PracticeWithSimba from '../../pages/faculty/practice-with-simba/PracticeWithSimba'
import PracticeSession from '../../pages/faculty/practice-with-simba/PracticeSession'
import AuditSimbaAi from '../../pages/audit/AuditSimbaAi'
import PracticeSessionsStats from '../audit/practice-with-simba/PracticeSessionsStats'
import AuditPracticeSessionsList from '../audit/practice-with-simba/AuditPracticeSessionsList'
import FeaturePermissions from '../../pages/admin/FeaturePermissions'
import Unauthorized from '../../pages/Unauthorized'
import Impersonation from '../../pages/admin/Impersonation'
import ProtectedSubadminComponent from './ProtectedSubadminComponent'
import ImpersonationSingin from '../../pages/ImpersonationSingin'
import AdminActivityLogs from '../../pages/admin/logging/AdminActivityLogs'
import AuditPracticeSessionsIssues from '../audit/practice-with-simba/AuditPracticeSessionsIssues'
import HybridClassDetailsForStudent from '../../pages/meetings/HybridClassDetailsForStudent'
import ScheduledWorkers from '../../pages/admin/ScheduledWorkers'
// import AliveLogin from '../../pages/AliveLogin'


const AppRoutes = observer( () => {

    return (
        <Router>
            <Routes>
                <Route exact path='/stream-ended' element={<StreamSessionEnded />} />
                <Route path='/assessment/login' element={<CandidateLogin />} />
                <Route exact path='/session/:access_token' element={<ERPSessionSingin />} />
                <Route exact path='/impersonation/:impersonation_type/:access_token' element={<ImpersonationSingin />} />
                <Route path='/admin/login' element={<AdminSignin />} />
                <Route path='/admin' element={<AdminSignin />} />
                {/* <Route exact path='/' element={<AliveLogin />} /> */}


                <Route path="/meetings" element={<OnlineMeetingsHome />} />
                <Route path="/webinar/:meeting_id" element={<WebinarRoom />} />
                <Route path="/meeting/:meeting_id" element={<WebinarRoom />} />
                <Route path="/class/:meeting_id" element={<WebinarRoom />} />
                <Route path="/hybrid-class/:meeting_id" element={<WebinarRoom />} />
                <Route path="/webinar/:meeting_id/record" element={<MeetingRecorder />} />
                <Route path="/meeting/:meeting_id/record" element={<MeetingRecorder />} />
                <Route path="/class/:meeting_id/record" element={<MeetingRecorder />} />
                <Route path="/hybrid-class/:meeting_id/record" element={<MeetingRecorder />} />
                <Route path="/webinar/:meeting_id/feedback" element={<MeetingFeedback />} />
                <Route path="/meeting/:meeting_id/feedback" element={<MeetingFeedback />} />
                <Route path="/class/:meeting_id/feedback" element={<MeetingFeedback />} />

                <Route exact path='*' element={<PageNotFound />} />

                <Route element={<AdmissionExamsRequireAuth allowedRoles={["STUDENT"]} />}>
                    <Route element={<AdmissionExamLayout />}>
                        <Route path="/thankyou" exact element={<ThankYouPage />} />
                        <Route path="/assessment/:id/:pid/attempt/:attempt" exact element={<AdmissionExamAttempt />} />
                        <Route path="/assessment/:id/:pid/worksheet-upload" exact element={<AdmissionExamWorksheetUpload />} />
                        <Route path="/assessment/:id/:pid/score" exact element={<CandidateParticipationResult />} />
                        <Route path="/assessment/" exact element={<CandidateExams />} />
                    </Route>
                </Route>

                <Route element={<RequireAuth allowedRoles={["ADMIN", "SUBADMIN"]} />}>
                    <Route element={<AdminLayout />} >

                        <Route path="/admin/assessment/" exact element={<AdmissionExams />} />
                        <Route path="/admin/assessment/new" exact element={<CreateAdmissionExam />} />
                        <Route path="/admin/assessment/:id" exact element={<AdmissionExam />} />
                        <Route path="/admin/assessment/:id/participation" exact element={<AdmissionExamParticipation />} />
                        <Route path="/admin/assessment/:id/evaluate/:participation_id" exact element={<AdmissionExamEvaluate />} />

                        <Route path='/admin/debug-logs' exact element={<DebugLogs />} />
                        <Route path='/admin/activity-logs' exact element={<AdminActivityLogs />} />

                        <Route path='/admin/resume-forms' element={<ResumeForms />} />
                        <Route path='/admin/resume-forms/:form_id' element={<ResumeForm />} />
                        <Route path='/admin/resume-entities' element={<ResumeEntities />} />
                        <Route path='/admin/resume-templates' element={<ResumeTemplates />} />
                        <Route path='/admin/resume-templates/:template_id' element={<ResumeTemplate />} />

                        <Route path='/admin/academic-rules' element={<InstituteAcademicRules />} />
                        <Route path='/admin/academics/audit' element={<AdminAcademicProgressAudit />} />
                        <Route path='/admin/academics/auditors' element={<AcademicProgressAuditors />} />
                        <Route path='/admin/academic-rule/:id/checklist' element={<DepartmentAcademicRuleChecklist />} />

                        <Route path='/admin/announcement' element={<Announcements />} />
                        <Route path='/admin/announcement/:announcement_id' element={<Announcement />} />

                        <Route path='/admin/help-center' element={<FAQs auth="admin" />} />

                        <Route path='/admin/hybrid-class-video-repository' element={<HybridClassVideosRepository />} />

                        <Route path='/admin/home' element={<Analytics />} />
                        <Route path='/admin/class-audit' element={<LiveClass />} />
                        <Route path='/admin/password' element={<Password />} />
                        <Route path='/admin/accounts' element={<ManageAccounts />} />
                        <Route path='/admin/attendance' element={<AttendanceAudit />} />
                        <Route path='/admin/control-panel' element={<ControlPanel />} />
                        <Route path='/admin/module-permissions' element={<FeaturePermissions />} />
                        <Route path='/admin/impersonation' element={
                            <ProtectedSubadminComponent permissionKey="impersonation">
                                <Impersonation />
                            </ProtectedSubadminComponent>
                        } />
                        <Route path='/admin/job-workers' element={
                            <ProtectedSubadminComponent permissionKey="workers">
                                <ScheduledWorkers />
                            </ProtectedSubadminComponent>
                        } />

                        {/* AUDITING */}
                        <Route path='/admin/audit' element={<AuditDashboard />} />
                        <Route path='/admin/assignments' element={<AuditAssignments />} >
                            <Route index element={<AssignmentsStats />} />
                            <Route path='list' element={<AssignmentList />} />
                        </Route>
                        <Route path='/admin/meetings' element={<AuditMeetings key="meetings" />} >
                            <Route index element={<MeetingsStats />} />
                            <Route path='list' element={<MeetingsList />} />
                        </Route>
                        <Route path='/admin/online-classes' element={<AuditMeetings key="classes" />} >
                            <Route index element={<MeetingsStats />} />
                            <Route path='list' element={<MeetingsList />} />
                        </Route>
                        <Route path='/admin/hybrid-classes' element={<AuditMeetings key="hybrid-classes" />} >
                            <Route index element={<MeetingsStats />} />
                            <Route path='list' element={<MeetingsList />} />
                        </Route>

                        <Route path='/admin/meetings/:meeting_id' element={<OnlineMeetingDetails />} />
                        <Route path='/admin/online-classes/:meeting_id' element={<OnlineMeetingDetails />} />
                        <Route path='/admin/hybrid-classes/:meeting_id' element={<OnlineMeetingDetails />} />

                        <Route path='/admin/exams' element={<AuditExams />} >
                            <Route index element={<ExamsStats />} />
                            <Route path='list' element={<AuditExamsList />} />
                        </Route>
                        <Route path='/admin/study-materials' element={<AuditStudyMaterials />} >
                            <Route index element={<StudyMaterialsStats />} />
                            <Route path='list' element={<AuditStudyMaterialsList />} />
                        </Route>
                        <Route path='/admin/quizzes' element={<AuditQuizzes />} >
                            <Route index element={<QuizzesStats />} />
                            <Route path='list' element={<AuditQuizzesList />} />
                        </Route>
                        <Route path='/admin/questionbanks' element={<AuditQuestionBanks />} >
                            <Route index element={<QuestionBanksStats />} />
                            <Route path='list' element={<AuditQuestionBanksList />} />
                        </Route>
                        <Route path='/admin/class-sessions' element={<AuditClassSessions />} >
                            <Route index element={<ClassSessionStats />} />
                            <Route path='list' element={<AuditClassSessionsList />} />
                        </Route>
                        <Route path='/admin/discussions' element={<AuditDiscussions />} >
                            <Route index element={<DiscussionsStats />} />
                            <Route path='list' element={<AuditDiscussionsList />} />
                        </Route>
                        <Route path='/admin/practice-with-simba' element={<AuditSimbaAi />} >
                            <Route index element={<PracticeSessionsStats />} />
                            <Route path='list' element={<AuditPracticeSessionsList />} />
                        </Route>
                        <Route path='/admin/practice-with-simba/issues' element={<ProtectedSubadminComponent permissionKey="auditing">
                            <AuditPracticeSessionsIssues />
                        </ProtectedSubadminComponent>} />

                        <Route path='/admin/discussions' element={<AuditDiscussions />} >
                            <Route index element={<DiscussionsStats />} />
                            <Route path='list' element={<AuditDiscussionsList />} />
                        </Route>
                        <Route path='/admin/faculty/:empcode' element={<FacultyAudit />} />

                        <Route path='/admin/feedback-setting' element={<FeedbackSettings />} />
                        <Route path='/admin/networkerror' element={<NetworkError />} />
                        <Route path='*' element={<PageNotFound />} />
                    </Route>
                </Route>



                <Route element={<RequireAuditAccess allowedRoles={['HOD', 'PRINCIPAL', 'ADMIN', 'SUBADMIN', 'is_auditor']} />}>
                    <Route element={<AuditingLayout />}>
                        <Route path='/audit' element={<AuditDashboard />} />
                        <Route path='/audit/assignments' element={<AuditAssignments />} >
                            <Route index element={<AssignmentsStats />} />
                            <Route path='list' element={<AssignmentList />} />
                        </Route>
                        <Route path='/audit/meetings' element={<AuditMeetings key="class" />} >
                            <Route index element={<MeetingsStats />} />
                            <Route path='list' element={<MeetingsList />} />
                            <Route path=':meeting_id' element={<OnlineMeetingDetails />} />
                        </Route>
                        <Route path='/audit/online-classes' element={<AuditMeetings key="meetings" />} >
                            <Route index element={<MeetingsStats />} />
                            <Route path='list' element={<MeetingsList />} />
                            <Route path=':meeting_id' element={<OnlineMeetingDetails />} />
                        </Route>
                        <Route path='/audit/hybrid-classes' element={<AuditMeetings key="hybrid-classes" />} >
                            <Route index element={<MeetingsStats />} />
                            <Route path='list' element={<MeetingsList />} />
                            <Route path=':meeting_id' element={<OnlineMeetingDetails />} />
                        </Route>
                        <Route path='/audit/exams' element={<AuditExams />} >
                            <Route index element={<ExamsStats />} />
                            <Route path='list' element={<AuditExamsList />} />
                        </Route>
                        <Route path='/audit/study-materials' element={<AuditStudyMaterials />} >
                            <Route index element={<StudyMaterialsStats />} />
                            <Route path='list' element={<AuditStudyMaterialsList />} />
                        </Route>
                        <Route path='/audit/quizzes' element={<AuditQuizzes />} >
                            <Route index element={<QuizzesStats />} />
                            <Route path='list' element={<AuditQuizzesList />} />
                        </Route>
                        <Route path='/audit/questionbanks' element={<AuditQuestionBanks />} >
                            <Route index element={<QuestionBanksStats />} />
                            <Route path='list' element={<AuditQuestionBanksList />} />
                        </Route>
                        <Route path='/audit/class-sessions' element={<AuditClassSessions />} >
                            <Route index element={<ClassSessionStats />} />
                            <Route path='list' element={<AuditClassSessionsList />} />
                        </Route>
                        <Route path='/audit/discussions' element={<AuditDiscussions />} >
                            <Route index element={<DiscussionsStats />} />
                            <Route path='list' element={<AuditDiscussionsList />} />
                        </Route>
                        <Route path='/audit/practice-with-simba' element={<AuditSimbaAi />} >
                            <Route index element={<PracticeSessionsStats />} />
                            <Route path='list' element={<AuditPracticeSessionsList />} />
                        </Route>


                        <Route path='/audit/faculty/:empcode' element={<FacultyAudit />} />
                    </Route>
                    <Route exact path='/audit/unauthorized' element={<Unauthorized />} />
                </Route>

                <Route element={<RequireAuth allowedRoles={["HOD", "PRESENTER", "FACULTY", "PRINCIPAL"]} />}>
                    <Route element={<PresenterLayout />}>

                        <Route path='/faculty/audit' element={<LiveClass />} />
                        <Route path='/faculty/stream' element={<EmbeddBbb />} />
                        <Route path='/faculty/home' element={<FacultyDashboard />} />
                        {/* <Route path='/faculty/attendance' element={<Attendence />} /> */}
                        <Route path='/faculty/assignment' element={<Assignment />} />
                        <Route path='/faculty/recordings' element={<PresenterRecording />} />
                        <Route path='/faculty/assignment/:assignment_id' element={<EvaluateAssignment />} />

                        <Route path="/faculty/online-classes" element={<OnlineMeetings key="class" meetingType='class' />} />
                        <Route path="/faculty/hybrid-classes" element={<OnlineMeetings key="hybrid-class" meetingType='hybrid-class' />} />
                        <Route path="/faculty/meetings" element={<OnlineMeetings key="meetings" />} />
                        <Route path="/faculty/meeting/:meeting_id" element={<OnlineMeetingDetails />} />
                        <Route path="/faculty/class/:meeting_id" element={<OnlineMeetingDetails />} />
                        <Route path="/faculty/webinar/:meeting_id" element={<OnlineMeetingDetails />} />
                        <Route path="/faculty/hybrid-class/:meeting_id" element={<OnlineMeetingDetails />} />

                        <Route path='/faculty/class-sessions' element={<SubjectClassSessions />} />


                        {/* Academics */}
                        {/* <Route path='/faculty/proctoring/proctees' element={<Proctees />} /> */}
                        {/* <Route path='/faculty/academics/audit' element={<AcademicProgressAudit />} /> */}
                        {/* <Route path='/faculty/proctoring/proctee/:student_auid' element={<Proctee />} /> */}

                        <Route path='/faculty/material' element={<FacultyMaterials />} />
                        <Route path='/faculty/material/add' element={<AddMaterial />} />
                        <Route path='/faculty/material/:material_id' element={<Material />} />

                        <Route path='/faculty/quizzes' element={<Quizzes fromComponent="page" />} />
                        <Route path='/faculty/quizzes/:id' element={<Quiz fromComponent="page" />} />
                        <Route path='/faculty/questionbank' element={<QuestionBanks fromMainPage />} />
                        <Route path='/faculty/questionbank/:bank_id' element={<QuestionBank fromMainPage />} />

                        <Route path='/faculty/exams' element={<Exams />} />
                        <Route path='/faculty/exams/:id' element={<Exam />} />
                        {/* <Route path='/faculty/addexam' element={<AddExam />} /> */}
                        <Route path='/faculty/exams/:id/edit' element={<EditExam />} />
                        <Route path='/faculty/participations' element={<AllParticipations />} />
                        <Route path='/faculty/exams/:id/addquestions' element={<AddQuestions />} />
                        <Route path='/faculty/exams/:id/participation' element={<ExamParticipation />} />
                        <Route path='/faculty/exams/:id/evaluate/:participation_id' element={<Evaluate />} />

                        <Route path='/faculty/discussions' element={<Discussions />} >
                            <Route path=':id' element={<Discussion fromComponent />} />
                        </Route>
                        <Route path='/faculty/my-discussions' element={<MyDiscussions />} >
                            <Route path=':id' element={<Discussion fromComponent />} />
                        </Route>
                        <Route path='/faculty/discussion/:id' element={<Discussion />} />

                        <Route path='/faculty/practice-with-simba' element={
                            <ProtectedFeature featureKey="simba_ai" ><PracticeWithSimba /></ProtectedFeature>
                        } />
                        <Route path='/faculty/practice-with-simba/:id' element={
                            <ProtectedFeature featureKey="simba_ai" ><PracticeSession /></ProtectedFeature>
                        } />

                        {/* <Route path='/faculty/subject/:subject_code' element={<Subject />} >
                            <Route path='home' element={<SubjectDashboard />} />
                            <Route path='aimentor' element={<AiMentorFaculty />} />

                            <Route path='class-sessions' element={<SubjectClassSessions />} />
                            <Route path='class-sessions/:session_id' element={<ClassSession />} />

                            <Route path='classes' element={<SubjectClasses />} />
                            <Route path='assignments' element={<SubjectAssignments />} />
                            <Route path='exams' element={<SubjectExams />} />
                            <Route path='exams/:id' element={<Exam fromSubject />} />
                            <Route path='discussions' element={<SubjectDiscussions />} >
                                <Route path=':id' element={<Discussion fromComponent />} />
                            </Route>
                            <Route path='questionbank' element={<QuestionBanks />} />
                            <Route path='questionbank/:bank_id' element={<QuestionBank />} />
                            <Route path='quiz' element={<Quizzes />} />
                            <Route path='quiz/:id' element={<Quiz />} />
                            <Route path='materials' element={<SubjectMaterials />} />
                            <Route path='materials/:material_id' element={<Material fromSubject />} />
                        </Route> */}

                        <Route path='/faculty/notfound' element={<Notfound />} />
                        <Route path='/faculty/examnotfound' element={<ExamNotfound />} />
                        <Route path='/faculty/networkerror' element={<NetworkError />} />
                        <Route exact path='/faculty/tutorials-and-manuals' element={<FAQs auth="faculty" />} />

                        <Route exact path='/faculty/unauthorized' element={<Unauthorized />} />

                        <Route path='*' element={<PageNotFound />} />
                    </Route>
                </Route>

                <Route element={<RequireAuth allowedRoles={["STUDENT"]} />}>
                    <Route element={<UserLayout />}>

                        <Route path='/student/home' element={<StudentDashboard />} />
                        <Route path='/student/stream' element={<EmbeddBbb />} />
                        <Route path='/student/dashboard' element={<StudentDashboard />} />
                        <Route path='/student/feedback' element={<SessionFeedback />} />
                        <Route path='/student/assignment' element={<UserAssignment />} />
                        {/* <Route path='/student/attendance' element={<UserAttendence />} /> */}

                        <Route path='/student/subjects' element={<Subjects />} />
                        <Route path='/student/subject/:subject_code' element={<Subject />} >
                            <Route path='home' element={<SubjectDashboard />} />
                            <Route path='class-sessions' element={<SubjectClassSessions />} />
                            <Route path='class-sessions/:session_id' element={<ClassSession />} />

                            <Route path='classes' element={<SubjectClasses />} />
                            <Route path='assignments' element={<SubjectAssignments />} />
                            <Route path='exams' element={<SubjectExams />} />
                            <Route path='exams/:id' element={<Exam fromSubject />} />
                            <Route path='discussions' element={<SubjectDiscussions />} >
                                <Route path=':id' element={<Discussion fromComponent />} />
                            </Route>
                            {/* <Route path='online-courses' element={<SubjectOnlineCourses />} /> */}
                            <Route path='materials' element={<SubjectMaterials />} />
                            <Route path='materials/:material_id' element={<Material fromSubject />} />
                        </Route>

                        <Route path='/student/class-sessions' element={<SubjectClassSessions />} />
                        {/* <Route path='/student/academics' element={<Academics />} /> */}


                        <Route path='/student/leaderboard' element={<Leaderboard />} />

                        <Route path='/student/material' element={<Materials />} />
                        <Route path='/student/material/:material_id' element={<Material />} />

                        <Route path="/student/hybrid-classes" element={<OnlineMeetings key="hybrid-class" meetingType='hybrid-class' />} />
                        <Route path="/student/hybrid-class/:meeting_id" element={<HybridClassDetailsForStudent />} />

                        <Route path='/student/exams' element={<Exams />} />
                        <Route path='/student/scores/:exam_id' element={<Scores />} />
                        <Route path='/student/exams/:id' element={<Exam />} />
                        <Route path='/student/notfound' element={<Notfound />} />
                        <Route path='/student/examnotfound' element={<ExamNotfound />} />
                        <Route path='/student/exams/:id/attempt/:attempt/:pid' element={<ExamAttempt />} />
                        <Route path='/student/scores/:exam_id/:participation_id' element={<StudentParticipationDetails />} />

                        <Route path='/student/quiz' element={<StudentQuiz />} />
                        <Route path='/student/quiz/:quiz_id/:instance_id/attempt/:attempt_id' element={<QuizAttempt />} />
                        <Route path='/student/hybrid-class/:hybrid_class_id/quiz/:quiz_id/:instance_id/attempt/:attempt_id' element={<QuizAttempt />} />

                        <Route path='/student/resume-builder' element={<ResumeBuilderForm />} />
                        <Route path='/student/resume-builder/preview' element={<ResumePreview />} />

                        {/* <Route path='/student/ai-tutor' element={<AiTutor />} /> */}

                        <Route path='/student/discussions' element={<Discussions />} >
                            <Route path=':id' element={<Discussion fromComponent />} />
                        </Route>
                        <Route path='/student/discussion/:id' element={<Discussion />} />
                        <Route path='/student/my-discussions' element={<MyDiscussions />} >
                            <Route path=':id' element={<Discussion fromComponent />} />
                        </Route>

                        <Route path='/student/networkerror' element={<NetworkError />} />
                        <Route exact path='/student/tutorials-and-manuals' element={<FAQs auth="student" />} />

                        <Route exact path='/student/unauthorized' element={<Unauthorized />} />

                        <Route path='*' element={<PageNotFound />} />
                    </Route>
                </Route>
            </Routes>
        </Router>
    )
} )

export default AppRoutes
